// Imports => Utilities
import { AcUUID } from '@utils';

// Imports => Constants
import { KEYS, TITLES } from '@constants';

export const OrderChange = class {
	constructor(products) {
		this.products = products;

		return this.create();
	}

	create = () => {
		return {
			id: AcUUID(),
			type: KEYS.CHANGE,
			title: TITLES.ORDER_CHANGE,
			products: this.products.map(product => ({ ...product, value: '' })),
		};
	};
};

export default OrderChange;
